import React, { useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BackButton from '../../components/backButton'
import { updateAllotment } from "./api";
const Payment = () => {
    const navigate = useNavigate();
    const { ...params } = useParams()

    useEffect(() =>{
        update()
    },[])

    const update = async () => {
        let data = await updateAllotment(params.id)
    }

    return (
        <>
            <div className="card  application-box">
                <BackButton to='/application' light />
                <div className="card-header">
                    <div className='card-header-container'>
                        <div></div>
                        <div>
                            <i className='fa fa-credit-card'></i> Payment Info
                        </div>
                        <div></div>
                    </div>
                </div>
                <div id="applications" className='application-body application-form-box'>
                    <div className='card application-form'>
                        <h2 className="ui_section_title">Payment Details</h2>
                        {/* <p align="center"><i style={{ color: 'red', fontSize: '16px' }}>Your payment is successful. Click the link below to view and download admit card</i></p> */}
                        <br />
                        <p align="center" style={{ color: 'red', }}>Your payment is failed. Please click on the link below try again</p>
                        <p align="center"><strong>Reason: </strong>Transaction authorization failed</p>
                    </div>
                </div>
                <div className="d-grid gap-2">
                    <button onClick={() => navigate("/step3")} className="btn btn-primary" type="button"><i className="fa fa-credit-card"></i>&nbsp;Go to payment page</button>
                </div>
            </div>
            <br />
            <br /><br />
        </>
    )
}

export default Payment